import React, { useState, useEffect } from 'react';
import { Row, Col, Input, Select, Divider, Table, Button } from 'antd';
import { fetchData, sendData } from '../../httpRequests';
import { useNavigate, useParams } from 'react-router-dom';
import { getPharmacyId } from '../../components/Shared';

const { Search } = Input;
const { Option } = Select;

export default function AdminPharmacyCategories() {
	const { id } = useParams();
	const navigate = useNavigate();
	const [filteredCategories, setFilteredCategories] = useState([]);
	const [categories, setCategories] = useState([]);

	useEffect(() => {
		loadCategories();
	}, []);

	const loadCategories = () => {
		const pharmacyId = getPharmacyId();
		if (!pharmacyId) {
			navigate('/login');
			return false;
		}

		checkUserAdmin(getPharmacyId());

		const url = '/categories/getCategories';
		fetchData(url).then((response) => {
			if (Object.keys(response).length > 0) {
				const categories = response['category'];

				const url = '/categories/getCategoriesStatus/' + id;
				fetchData(url).then((response) => {
					if (Object.keys(response).length > 0) {
						const categoriesStatus = response['categoryStatus'];
						categories.map((category) => {
							const categoryStatus = categoriesStatus.find(
								(cStatus) => cStatus.category_id == category.id
							);
							if (categoryStatus) {
								category.status = categoryStatus.status;
								category.category_status_id = categoryStatus.id;
							} else {
								category.status = 0;
							}
						});
					}
					setCategories(categories);
					setFilteredCategories(categories);
				});
			}
		});
	};

	const checkUserAdmin = (pharmacyId) => {
		const url = '/pharmacies/getPharmacyById';
		const data = {
			id: pharmacyId
		};
		sendData(url, data).then((response) => {
			const pharmacy = response['pharmacy'];
			if (pharmacy.role_id != 4&&pharmacy.role_id!=5) navigate('/orders');
		});

		return false;
	};

	const onSearch = (value) => {
		const text = value.target.value;
		setTimeout(() => {
			if (text) {
				const filteredCategories = categories.filter((category) => category.name.includes(text));
				setFilteredCategories(filteredCategories);
			} else {
				setFilteredCategories(categories);
			}
		}, 1000);
	};

	const handleChange = (value) => {
		if (value) {
			const status = (value == 1 && value) || 0;
			const filteredCategories = categories.filter((category) => category.status == status);
			setFilteredCategories(filteredCategories);
		} else {
			setFilteredCategories(categories);
		}
	};

	const changeCategoryStatus = (categoryId, status, categoryStatus) => {
		let url = '/categories/updateCategoriesStatus';
		const data = {
			pharmacy_id: id,
			category_id: categoryId,
			status: status
		};
		if (!categoryStatus) {
			url = '/categories/addCategoriesStatus';
		}
		sendData(url, data).then((response) => {
			loadCategories();
		});
	};

	const updateAllCategories = (status) => {
		categories.map((category) => {
			const categoryStatus = category.category_status_id;
			if (category.status != status) {
				changeCategoryStatus(category.id, status, categoryStatus);
			}
		});
	};

	const columns = [
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
			defaultSortOrder: 'ascend',
			sorter: (a, b) => a.name.localeCompare(b.name)
		},
		{
			title: 'Status',
			render: ({ status }) => {
				return <span>{(status == 1 && 'Active') || 'Inactive'}</span>;
			},
			key: 'status'
		},
		{
			title: 'Action',
			render: ({ id, status, category_status_id }) => {
				return (
					<Button
						type='primary'
						danger={status && true}
						style={{ borderRadius: 10, height: 35, width: 150 }}
						size='small'
						onClick={() => changeCategoryStatus(id, !status, (category_status_id && true) || false)}
					>
						{(status && 'Deactivate') || 'Activate'}
					</Button>
				);
			}
		}
	];

	return (
		<div>
			<Row gutter={24}>
				<Col span={12}>
					<Search size='large' placeholder='Search category by name' onChange={onSearch} />
				</Col>
				<Col span={12}>
					<Select
						placeholder='Select status'
						defaultValue={''}
						size='large'
						onChange={handleChange}
						style={{ width: '100%' }}
					>
						<Option value=''>All</Option>
						<Option value={1}>Active</Option>
						<Option value={2}>Inactive</Option>
					</Select>
				</Col>
			</Row>
			<Divider />
			<Row gutter={24}>
				<Col span={24} style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 20 }}>
					<Button
						onClick={() => updateAllCategories(1)}
						type='primary'
						style={{
							height: 40,
							color: '#fff',
							borderRadius: 10,
							fontSize: 16,
							width: 200,
							

							marginRight: 10
						}}
					>
						Activate All
					</Button>
					<Button
						onClick={() => updateAllCategories(0)}
						type='primary'
						danger={true}
						style={{
							height: 40,
							color: '#fff',
							borderRadius: 10,
							fontSize: 16,
							width: 200
						}}
					>
						Desactivate All
					</Button>
				</Col>
			</Row>
			<Row gutter={24}>
				<Col span={24}>
					<Table columns={columns} dataSource={filteredCategories} rowKey={(item) => item.id} />
				</Col>
			</Row>
		</div>
	);
}
